export default {
  catTable: [
    {
      id: 1,
      type: 'Very Low',
      Earthquake: '0.0116667',
      hydrometeorological: '0.0116667',
      Flood: '0.0116667',
      Other: '0.0116667',
    },
    {
      id: 2,
      type: 'Low',
      Earthquake: '0.0291667',
      hydrometeorological: '0.0350000',
      Flood: '0.0175000',
      Other: '0.0175000',
    },
    {
      id: 3,
      type: 'Medium',
      Earthquake: '0.0525000',
      hydrometeorological: '0.2216667',
      Flood: '0.0291667',
      Other: '0.0291667',
    },
    {
      id: 4,
      type: 'High',
      Earthquake: '0.0729167',
      hydrometeorological: '0.3500000',
      Flood: '0.0408333',
      Other: '0.0408333',
    },
    {
      id: 5,
      type: 'Very High',
      Earthquake: '0.0991667',
      hydrometeorological: '0.4666667',
      Flood: '0.1166667',
      Other: '0.1166667',
    },
  ],
  contractors: [
    {
      id: 1,
      type: 'CAR',
      occupancy: 'Residential industrial commercial and Municipal buildings (Five basements or less)',
      category: 'Very Low',
      monthlyRate: '5',
    },
    {
      id: 2,
      type: 'CAR',
      occupancy: 'Residential industrial commercial and Municipal buildings (More than five basements)',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 3,
      type: 'CAR',
      occupancy: 'Residential industrial commercial and Municipal buildings renovations',
      category: 'Very Low',
      monthlyRate: '5',
    },
    {
      id: 4,
      type: 'CAR',
      occupancy: 'Bridges (Span less than 15 m)',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 5,
      type: 'CAR',
      occupancy: 'Bridges (Span between 15 m and less than 25 m)',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 6,
      type: 'CAR',
      occupancy: 'Bridges (Span over 25 m)',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 7,
      type: 'CAR',
      occupancy: 'Dams',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 8,
      type: 'CAR',
      occupancy: 'Tunnels on solid rock',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 9,
      type: 'CAR',
      occupancy: 'Tunnels on unstable rock',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 10,
      type: 'CAR',
      occupancy: 'Tunnels (Open cut method)',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 11,
      type: 'CAR',
      occupancy: 'Site preparation and foundations',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 12,
      type: 'CAR',
      occupancy: 'Port Facilities including water works less than 25%',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 13,
      type: 'CAR',
      occupancy: 'Port Facilities including water works over 25% and less than 50%',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 14,
      type: 'CAR',
      occupancy: 'River and canal works',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 15,
      type: 'CAR',
      occupancy: 'Water treatment plants',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 16,
      type: 'CAR',
      occupancy: 'Aqueducts',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 17,
      type: 'CAR',
      occupancy: 'Irrigation systems',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 18,
      type: 'CAR',
      occupancy: 'Highway Construction without big structures',
      category: 'Very Low',
      monthlyRate: '5',
    },
    {
      id: 19,
      type: 'CAR',
      occupancy: 'Highway Construction with big structures',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 20,
      type: 'CAR',
      occupancy: 'Highway renovation (paving)',
      category: 'Very Low',
      monthlyRate: '5',
    },
    {
      id: 21,
      type: 'CAR',
      occupancy: 'Railways Construction',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 22,
      type: 'CAR',
      occupancy: 'Railways renovation',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 23,
      type: 'CAR',
      occupancy: 'Runways',
      category: 'Very Low',
      monthlyRate: '5',
    },
    {
      id: 24,
      type: 'CAR',
      occupancy: 'Stadiums',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 25,
      type: 'CAR',
      occupancy: 'Colosseums and Arenas',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 26,
      type: 'EAR',
      occupancy: 'Hydraulic power plants (Up to 25 MW per unit)',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 27,
      type: 'EAR',
      occupancy: 'Hydraulic power plants (Over 25 MW up to 50 MW per unit)',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 28,
      type: 'EAR',
      occupancy: 'Hydraulic power plants (Over 50 MW per unit)',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 29,
      type: 'EAR',
      occupancy: 'Combined cycle plant',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 30,
      type: 'EAR',
      occupancy: 'Gas Turbine Power Plants with Turbines with individual capacity over 100 MW',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 31,
      type: 'EAR',
      occupancy: 'Gas Turbine Power Plants with turbines with individual capacity below 100 MW',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 32,
      type: 'EAR',
      occupancy: 'Diesel fired power plants',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 33,
      type: 'EAR',
      occupancy: 'Gas fired power plants',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 34,
      type: 'EAR',
      occupancy: 'Waste fired power plants',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 35,
      type: 'EAR',
      occupancy: 'Windfarms',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 36,
      type: 'EAR',
      occupancy: 'Geothermal power plants',
      category: 'Very High',
      monthlyRate: '2',
    },
    {
      id: 37,
      type: 'EAR',
      occupancy: 'Solar cell power plants',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 38,
      type: 'EAR',
      occupancy: 'Transmission and Distribution Lines',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 39,
      type: 'EAR',
      occupancy: 'Switchyards',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 40,
      type: 'EAR',
      occupancy: 'Pipeline installation (Diameter under 12")',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 41,
      type: 'EAR',
      occupancy: 'Pipeline installation (Diameter over 12"and les than 22")',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 42,
      type: 'EAR',
      occupancy: 'Pipeline installation (Diameter over 22")',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 43,
      type: 'EAR',
      occupancy: 'Industrial Machinery - Heavy Industry',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 44,
      type: 'EAR',
      occupancy: 'Industrial machinery - Average Industry',
      category: 'Low',
      monthlyRate: '4',
    },
    {
      id: 45,
      type: 'EAR',
      occupancy: 'Industrial machinery - Light Industry',
      category: 'Very Low',
      monthlyRate: '5',
    },
    {
      id: 46,
      type: 'EAR',
      occupancy: 'Petrochemical risks with low management of hydrocarbons',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 47,
      type: 'EAR',
      occupancy: 'Petrochemical risks managing hydrocarbons',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 48,
      type: 'EAR',
      occupancy: 'Chemical Risks',
      category: 'High',
      monthlyRate: '3',
    },
    {
      id: 49,
      type: 'EAR',
      occupancy: 'Telecommunications equipment including antennas',
      category: 'Medium',
      monthlyRate: '4',
    },
    {
      id: 50,
      type: 'EAR',
      occupancy: 'Low tension equipment',
      category: 'Low',
      monthlyRate: '4',
    },
  ],
  monthlyRate: [
    {
      id: 5,
      monthlyRate: 'Very Low',
      rate: 0.0472083333333333,
    },
    {
      id: 4,
      monthlyRate: 'Low',
      rate: 0.064375,
    },
    {
      id: 3,
      monthlyRate: 'Medium',
      rate: 0.0815416666666667,
    },
    {
      id: 2,
      monthlyRate: 'High',
      rate: 0.1073,
    },
    {
      id: 1,
      monthlyRate: 'Very High',
      rate: 0.124458333333333,
    },
  ],
  typeofconstruction: [
    {
      id: 1,
      typeConstruction: '100% uncombustible',
      rate: 0.9,
    },
    {
      id: 2,
      typeConstruction: 'Up to 25% combustible material',
      rate: 1.0,
    },
    {
      id: 3,
      typeConstruction: 'Up to 50% combustible material',
      rate: 1.1,
    },
    {
      id: 4,
      typeConstruction: 'Up to 75% combustible material',
      rate: 1.3,
    },
    {
      id: 5,
      typeConstruction: 'Others',
      rate: 1.45,
    },
  ],
  testing: [
    {
      id: 1,
      testing: 'Only service equipment',
      rate: '1.0300',
    },
    {
      id: 2,
      testing: 'Machinery and equipment with additional risk',
      rate: '1.1000',
    },
    {
      id: 3,
      testing: 'No Coverage',
      rate: '1.0000',
    },
  ],
  thirdPartyLiability: [
    {
      id: 1,
      data: 'High',
      rate: 1.08,
    },
    {
      id: 2,
      data: 'Medium',
      rate: 1.06,
    },
    {
      id: 3,
      data: 'Low',
      rate: 1.03,
    },
    {
      id: 4,
      data: 'No Coverage',
      rate: 1.0,
    },
  ],
  SRCC: [
    {
      id: 1,
      data: 'High',
      rate: '1.1000',
    },
    {
      id: 2,
      data: 'Medium',
      rate: '1.0600',
    },
    {
      id: 3,
      data: 'Low',
      rate: '1.0400',
    },
    {
      id: 4,
      data: 'No Coverage',
      rate: '1.0000',
    },
  ],
  firstyearOp: [
    {
      id: 1,
      data: 'Yes',
      rate: '1.3500',
    },
    {
      id: 2,
      data: 'No',
      rate: '1',
    },
  ],
  inlandTransit: [
    {
      id: 1,
      data: 'High',
      rate: '1.0500',
    },
    {
      id: 2,
      data: 'Medium',
      rate: '1.0300',
    },
    {
      id: 3,
      data: 'Low',
      rate: '1.0200',
    },
    {
      id: 4,
      data: 'No Coverage',
      rate: '1.0000',
    },
  ],
  ALOP: [
    {
      id: 1,
      data: 'Very Low',
      factor: '1.9',
    },
    {
      id: 2,
      data: 'Low',
      factor: '2.9',
    },
    {
      id: 3,
      data: 'Medium',
      factor: '3.9',
    },
    {
      id: 4,
      data: 'High',
      factor: '4.9',
    },
    {
      id: 5,
      data: 'Very High',
      factor: '5.90',
    },
  ],
  errorsDesign: [
    {
      id: 1,
      data: 'No Coverage',
      rate: '1.0000',
    },
    {
      id: 2,
      data: 'Excluding faulty part, MR 200, MR 115, LEG2/96',
      rate: '1.0700',
    },
    {
      id: 3,
      data: 'Full design cover LEG3, DE4, DE5',
      rate: '1.1600',
    },
  ],
  equipmentInstallation: [
    {
      id: 1,
      data: 'Only service equipment',
      rate: '1.0700',
    },
    {
      id: 2,
      data: 'Machinery and equipment with additional risk',
      rate: '1.1200',
    },
    {
      id: 3,
      data: 'No Coverage',
      rate: '1.0000',
    },
  ],
  maintenancePeriod: [
    {
      id: 1,
      data: 'Visits',
      rate: '1.0300',
    },
    {
      id: 2,
      data: 'Extended',
      rate: '1.0600',
    },
    {
      id: 3,
      data: 'No Coverage',
      rate: '1.0000',
    },
  ],
  reasons: [
    {
      id: 1,
      data: 'Market',
    },
    {
      id: 2,
      data: 'Result',
    },
    {
      id: 3,
      data: 'Risk Quality',
    },
    {
      id: 4,
      data: 'Conditions',
    },
    {
      id: 5,
      data: 'Other (Explain Why)',
    },
  ],
};
